import shareIcon from "../../../../assets/images/share.svg";
import elemIcon from "../../../../assets/images/student-card.svg";

const WhySection = () => {
  return (
    <section id="why-doxbox" className="mb-3 ">
      <h1 className="text-center fs-56 py-4">Why DOXBOX!</h1>
      <div className="d-flex flex-wrap gap-4 pb-0 pb-md-5 gap-2">
        <div className="why-card d-flex flex-column border-radius-16 p-5 pb-1">
          <img
            src={shareIcon}
            alt="share-icon"
            className="share-icon fw-60 background-primary border-radius-20 p-3 mb-4"
          />
          <div>
            <h3 className="fs-4 py-3 fw-60" style={{ color: "#9A9A9A" }}>
              Share Smarter, Not Harder
            </h3>
            <h3 className="fs-4 pb-4 fw-50">
              Send what's needed, exactly when it's needed, securely and
              effortlessly.
            </h3>
            <p className="fs-6-mobile">
              Whether you are applying for a job, registering for school, or
              finalizing paperwork, DOXBOX makes sharing documents effortless
              and secure.
            </p>
          </div>
        </div>

        <div className="why-card d-flex flex-column border-radius-16 p-5 pb-1">
          <img
            src={elemIcon}
            alt="share-icon"
            className="share-icon fw-60 background-primary border-radius-20 p-3 mb-4"
          />
          <div>
            <h3 className="fs-4 py-3 fw-60" style={{ color: "#9A9A9A" }}>
              Your Business Card, Reimagined
            </h3>
            <h3 className="fs-4 pb-4 fw-50">
              Stand out with a smart card that updates in real time and shares
              instantly.
            </h3>
            <p className="fs-6-mobile">
              Your personal brand, contact info, Social Media, and professional
              profile, always ready, always polished.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhySection;
